import React, {ReactElement} from 'react';
import {bindActionCreators, Dispatch} from 'redux';
import {connect} from 'react-redux';
import {InfoText} from '@vizir-banking/banking-app-core/dist/common';
import {Bold, Text} from '@vizir-banking/banking-app-core/dist/layout';
import {SchemaNames} from '@vizir-banking/banking-app-core/dist/common/single-input-form/types';
import {addCreationUser} from '@vizir-banking/banking-app-core/dist/redux/onboarding/add-creation-user';
import {User} from '@vizir-banking/banking-app-core/dist/redux/user/types';

import {ONBOARDING_SCREENS} from '~/navigation/screen-definitions';
import translate from '~/i18n/translate';
import {
  OnboardingNavigationProps,
  withOnboardingNavigation,
} from '~/onboarding/navigation/with-onboarding-navigation';
import SingleInputForm from '~/onboarding/components/single-input-form/single-input-form';
import {OnboardingScreen} from '~/onboarding/components/screen-with-onboarding-progress/screen-with-onboarding-progress';

const actionCreators = {addCreationUser};

type Props = ReturnType<typeof mapDispatchToProps> & OnboardingNavigationProps;

class MotherNameScreen extends React.PureComponent<Props> {
  submit = (value: string): void => {
    const {navigateToNextOnboardingScreen, actions} = this.props;

    actions.addCreationUser('motherName', value);

    navigateToNextOnboardingScreen();
  };

  renderText(): ReactElement {
    return (
      <>
        <Text>
          {translate('onboarding.WhatIsYour')}
          <Bold> {translate('onboarding.MothersCompleteName')}</Bold>?
        </Text>
      </>
    );
  }

  render(): ReactElement {
    return (
      <OnboardingScreen showProgress>
        <SingleInputForm
          reduxValueKey="motherName"
          validationSchemaName={SchemaNames.NAME}
          content={this.renderText}
          onSubmit={this.submit}
          maxLength={80}
          autoCapitalize="words"
        >
          <InfoText
            title={translate('onboarding.MotherNameInfoButton')}
            text={translate('onboarding.MotherNameInfoText')}
          />
        </SingleInputForm>
      </OnboardingScreen>
    );
  }
}

type Actions = {
  addCreationUser: (fieldName: keyof User, value: string) => void;
};

const mapDispatchToProps = (dispatch: Dispatch): {actions: Actions} => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

export default connect(
  null,
  mapDispatchToProps,
)(withOnboardingNavigation(MotherNameScreen, ONBOARDING_SCREENS.motherName));
